<template>
  <b-form-group
    label="6. Indikasi Tercatat Ganda"
    label-for="isIndikasiGanda"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-form-radio
      v-model="isIndikasiGanda"
      :state="stateIsIndikasiGanda"
      value="1"
    >
      Terindikasi Tercatat Ganda Dengan
    </b-form-radio>
    <b-col
      v-if="isIndikasiGanda === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-select
        id="indikasiGandaDengan"
        v-model="indikasiGandaDengan"
        :state="stateIndikasiGandaDengan"
        :options="dataIndikasiGandaDengan"
        @change="changeIndikasiGandaDengan"
      />
      <b-form-invalid-feedback
        v-for="(error, index) of errorsIndikasiGandaDengan"
        :key="index"
      >
        {{ error.$message }}
      </b-form-invalid-feedback>

      <b-col
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          v-if="indikasiGandaDengan === '1' || indikasiGandaDengan === '2'"
          label="Sebutkan"
          label-for="indikasiGandaSebutkan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-input
            id="indikasiGandaSebutkan"
            v-model="indikasiGandaSebutkan"
            :state="stateIndikasiGandaSebutkan"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsIndikasiGandaSebutkan"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <div v-if="indikasiGandaDengan === '3'">
          <b-form-group
            label=""
            label-for="indikasiGandaPdUkpd"
            label-size="lg"
            label-class="pb-0 pt-0"
          >
            <v-select
              id="indikasiGandaPdUkpd"
              v-model="indikasiGandaPdUkpd"
              :state="stateIndikasiGandaPdUkpd"
              :options="dataIndikasiGandaPdUkpd"
              label="text"
              @input="inputIndikasiGandaPdUkpd"
            />
            <small
              v-for="(error, index) of errorsIndikasiGandaPdUkpd"
              :key="index"
              class="text-danger"
            >
              {{ error.$message }}
            </small>
          </b-form-group>

          <b-overlay
            :show="isLoadIndikasiGandaPdUkpd"
            variant="light"
            opacity="0.85"
            blur="2px"
            rounded="sm"
          >
            <b-form-group
              v-if="indikasiGandaPdUkpd.value"
              label="Kode Barang"
              label-for="indikasiGandaKobar"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <v-select
                id="indikasiGandaKobar"
                v-model="indikasiGandaKobar"
                :state="stateIndikasiGandaKobar"
                :options="dataIndikasiGandaKobar"
                label="text"
                @search="searchIndikasiGandaKobar"
                @input="inputIndikasiGandaKobar"
              />
              <small
                v-for="(error, index) of errorsIndikasiGandaKobar"
                :key="index"
                class="text-danger"
              >
                {{ error.$message }}
              </small>
            </b-form-group>
          </b-overlay>

          <b-overlay
            :show="isLoadIndikasiGandaRegister"
            variant="light"
            opacity="0.85"
            blur="2px"
            rounded="sm"
          >
            <b-form-group
              v-if="indikasiGandaPdUkpd.value && indikasiGandaKobar.value"
              label="Register"
              label-for="indikasiGandaRegister"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <v-select
                id="indikasiGandaRegister"
                v-model="indikasiGandaRegister"
                :state="stateIndikasiGandaRegister"
                :options="dataIndikasiGandaRegister"
                label="text"
              />
              <small
                v-for="(error, index) of errorsIndikasiGandaRegister"
                :key="index"
                class="text-danger"
              >
                {{ error.$message }}
              </small>
            </b-form-group>
          </b-overlay>
        </div>
      </b-col>
    </b-col>
    <b-form-radio
      v-model="isIndikasiGanda"
      :state="stateIsIndikasiGanda"
      value="0"
    >
      Tidak Tercatat Ganda
    </b-form-radio>
    <small
      v-for="(error, index) of errorsIsIndikasiGanda"
      :key="index"
      class="text-danger"
    >
      {{ error.$message }}
    </small>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  propsString,
  propsBoolean,
  propsArray,
  propsObject,
} from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const isIndikasiGanda = ref('')
    const indikasiGandaDengan = ref(null)
    const indikasiGandaSebutkan = ref('')
    const indikasiGandaPdUkpd = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const indikasiGandaKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const indikasiGandaRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })

    watch(isIndikasiGanda, () => {
      context.emit('emitIsIndikasiGanda', isIndikasiGanda.value)
    })

    watch(indikasiGandaDengan, () => {
      context.emit('emitIndikasiGandaDengan', indikasiGandaDengan.value)
    })

    watch(indikasiGandaSebutkan, () => {
      context.emit('emitIndikasiGandaSebutkan', indikasiGandaSebutkan.value)
    })

    watch(indikasiGandaPdUkpd, () => {
      context.emit('emitIndikasiGandaPdUkpd', indikasiGandaPdUkpd.value)
    })

    watch(indikasiGandaKobar, () => {
      context.emit('emitIndikasiGandaKobar', indikasiGandaKobar.value)
    })

    watch(indikasiGandaRegister, () => {
      context.emit('emitIndikasiGandaRegister', indikasiGandaRegister.value)
    })

    watchEffect(() => {
      isIndikasiGanda.value = props.isIndikasiGandaVal
      indikasiGandaDengan.value = props.indikasiGandaDenganVal
      indikasiGandaSebutkan.value = props.indikasiGandaSebutkanVal
      indikasiGandaPdUkpd.value = props.indikasiGandaPdUkpdVal
      indikasiGandaKobar.value = props.indikasiGandaKobarVal
      indikasiGandaRegister.value = props.indikasiGandaRegisterVal
    })

    const changeIndikasiGandaDengan = () => {
      context.emit('emitChangeIndikasiGandaDengan')
    }

    const inputIndikasiGandaPdUkpd = () => {
      context.emit('emitInputIndikasiGandaPdUkpd', indikasiGandaPdUkpd.value)
    }

    const inputIndikasiGandaKobar = () => {
      context.emit('emitInputIndikasiGandaKobar', indikasiGandaKobar.value)
    }

    const searchIndikasiGandaKobar = search => {
      context.emit('emitSearchIndikasiGandaKobar', search)
    }

    return {
      isIndikasiGanda,
      indikasiGandaDengan,
      indikasiGandaSebutkan,
      indikasiGandaPdUkpd,
      indikasiGandaKobar,
      indikasiGandaRegister,
      changeIndikasiGandaDengan,
      inputIndikasiGandaPdUkpd,
      inputIndikasiGandaKobar,
      searchIndikasiGandaKobar,
    }
  },
  components: {
    vSelect,
  },
  props: {
    isIndikasiGandaVal: propsString,
    stateIsIndikasiGanda: propsBoolean,
    errorsIsIndikasiGanda: propsArray,
    indikasiGandaDenganVal: propsString,
    dataIndikasiGandaDengan: propsArray,
    stateIndikasiGandaDengan: propsBoolean,
    errorsIndikasiGandaDengan: propsArray,
    indikasiGandaSebutkanVal: propsString,
    stateIndikasiGandaSebutkan: propsBoolean,
    errorsIndikasiGandaSebutkan: propsArray,
    indikasiGandaPdUkpdVal: propsObject,
    dataIndikasiGandaPdUkpd: propsArray,
    stateIndikasiGandaPdUkpd: propsBoolean,
    errorsIndikasiGandaPdUkpd: propsArray,
    isLoadIndikasiGandaPdUkpd: propsBoolean,
    isLoadIndikasiGandaRegister: propsBoolean,
    indikasiGandaKobarVal: propsObject,
    dataIndikasiGandaKobar: propsArray,
    stateIndikasiGandaKobar: propsBoolean,
    errorsIndikasiGandaKobar: propsArray,
    indikasiGandaRegisterVal: propsObject,
    dataIndikasiGandaRegister: propsArray,
    stateIndikasiGandaRegister: propsBoolean,
    errorsIndikasiGandaRegister: propsArray,
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
